import React from "react";

// Styles
import "./index.scss";
//Constants
import * as Constants from "../../constants";

const signouturl =
  Constants.entitiesSignoutOriginObject[window.location.origin];

export default function Index() {
  return (
    <div className="unAUthContainer">
      {/* <p>
        Please ensure you are logged in and are authorized to access this page
        and try again.
      </p> */}
      <div>
        This portal is accessible to current IEEE SA entity members. If you
        believe you are an IEEE SA entity member in good standing, please check
        your login information and try again.
      </div>
      <div>
        If the situation persists, please contact
        <a href={"corp-mem@ieee.org"}>corp-mem@ieee.org</a>for further
        information.
        <a href={signouturl}>Click here to Logout.</a>
        {/* If this issue persists, please contact
        <a href="https://sagroups.ieee.org/myproject-help/contact/">
          IEEE Support.
        </a> */}
      </div>
    </div>
  );
}
